function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal } from "@common/actions";
import BoxDetailsTab from "@common/components/BoxDetailsTab";
import SideBarMenu from "@common/components/SideBarMenu";
import { formatPrice, replaceWith } from "@common/services/helpers";
import { getItemPrice } from "@common/utils/helpers";
import PrismicClient from "@common/utils/prismic";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import { isNil } from "lodash";
import { withSnackbar } from "notistack";
var BoxSpecification = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(BoxSpecification, Component);
    var _super = _create_super(BoxSpecification);
    function BoxSpecification(props) {
        _class_call_check(this, BoxSpecification);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeComponentId: null,
            currentBoxDetails: {}
        };
        _this.toggleComponent = _this.toggleComponent.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(BoxSpecification, [
        {
            /**
     *  Toggle the active component by setting its name as activeComponentName
     *  which is then mapped to COMPONENT_MAP component objects
     *  @param {string} component
     */ key: "toggleComponent",
            value: function toggleComponent(component) {
                this.setState(function() {
                    return {
                        activeComponentId: component
                    };
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _currentBoxDetails_body_, _currentBoxDetails_body, addon, stbDetails, e, currentBoxDetails, activeComponentId;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                addon = _this.props.addon;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getStbDetails()
                                ];
                            case 2:
                                stbDetails = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                console.error(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                currentBoxDetails = stbDetails === null || stbDetails === void 0 ? void 0 : stbDetails.find(function(box) {
                                    return (box === null || box === void 0 ? void 0 : box.stb_id) === (addon === null || addon === void 0 ? void 0 : addon.id);
                                });
                                if (isNil(currentBoxDetails)) {
                                    _this.props.enqueueSnackbar(_this.props.i18n.errors.generic, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                    _this.props.closeModal();
                                }
                                activeComponentId = currentBoxDetails === null || currentBoxDetails === void 0 ? void 0 : (_currentBoxDetails_body = currentBoxDetails.body) === null || _currentBoxDetails_body === void 0 ? void 0 : (_currentBoxDetails_body_ = _currentBoxDetails_body[0]) === null || _currentBoxDetails_body_ === void 0 ? void 0 : _currentBoxDetails_body_.id;
                                _this.setState({
                                    currentBoxDetails: currentBoxDetails,
                                    activeComponentId: activeComponentId
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _currentBoxDetails_header_title_, _currentBoxDetails_header_title, _currentBoxDetails_footer_text_, _currentBoxDetails_footer_text, _currentBoxDetails_stb_name_, _currentBoxDetails_stb_name, _COMPONENT_MAP_activeComponentId;
                var _this_props = this.props, i18n = _this_props.i18n, addon = _this_props.addon, addonPrismic = _this_props.addonPrismic;
                var _this_state = this.state, activeComponentId = _this_state.activeComponentId, currentBoxDetails = _this_state.currentBoxDetails;
                var headerTitle = currentBoxDetails === null || currentBoxDetails === void 0 ? void 0 : (_currentBoxDetails_header_title = currentBoxDetails.header_title) === null || _currentBoxDetails_header_title === void 0 ? void 0 : (_currentBoxDetails_header_title_ = _currentBoxDetails_header_title[0]) === null || _currentBoxDetails_header_title_ === void 0 ? void 0 : _currentBoxDetails_header_title_.text;
                var footerText = currentBoxDetails === null || currentBoxDetails === void 0 ? void 0 : (_currentBoxDetails_footer_text = currentBoxDetails.footer_text) === null || _currentBoxDetails_footer_text === void 0 ? void 0 : (_currentBoxDetails_footer_text_ = _currentBoxDetails_footer_text[0]) === null || _currentBoxDetails_footer_text_ === void 0 ? void 0 : _currentBoxDetails_footer_text_.text;
                var stbName = currentBoxDetails === null || currentBoxDetails === void 0 ? void 0 : (_currentBoxDetails_stb_name = currentBoxDetails.stb_name) === null || _currentBoxDetails_stb_name === void 0 ? void 0 : (_currentBoxDetails_stb_name_ = _currentBoxDetails_stb_name[0]) === null || _currentBoxDetails_stb_name_ === void 0 ? void 0 : _currentBoxDetails_stb_name_.text;
                var COMPONENT_MAP = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ((currentBoxDetails === null || currentBoxDetails === void 0 ? void 0 : currentBoxDetails.body) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tabProps = _step.value;
                        var _tabProps_primary_tab_name_, _tabProps_primary_tab_name, _tabProps_primary;
                        var title = (_tabProps_primary = tabProps.primary) === null || _tabProps_primary === void 0 ? void 0 : (_tabProps_primary_tab_name = _tabProps_primary.tab_name) === null || _tabProps_primary_tab_name === void 0 ? void 0 : (_tabProps_primary_tab_name_ = _tabProps_primary_tab_name[0]) === null || _tabProps_primary_tab_name_ === void 0 ? void 0 : _tabProps_primary_tab_name_.text;
                        var tabId = tabProps.id;
                        COMPONENT_MAP[tabId] = {
                            component: BoxDetailsTab,
                            componentName: tabId,
                            title: title,
                            props: tabProps
                        };
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Here we pass configuration data for the sidebar menu
                // Making tabs from the components we need
                var sideMenuTabs = Object.values(COMPONENT_MAP);
                var title1 = (_COMPONENT_MAP_activeComponentId = COMPONENT_MAP[activeComponentId]) === null || _COMPONENT_MAP_activeComponentId === void 0 ? void 0 : _COMPONENT_MAP_activeComponentId.title;
                var activeComponent = COMPONENT_MAP[activeComponentId];
                var _$Component = activeComponent === null || activeComponent === void 0 ? void 0 : activeComponent.component;
                var currencyCode = addon.currencyCode;
                var _getItemPrice = getItemPrice(addon, addonPrismic), originalPrice = _getItemPrice.originalPrice, discountedPrice = _getItemPrice.discountedPrice, hasPromoPrice = _getItemPrice.hasPromoPrice;
                return isNil(activeComponentId) ? /*#__PURE__*/ _jsx("span", {
                    children: "TEST LOADING"
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "modal box-specification-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "modal-title-wrapper",
                                    children: /*#__PURE__*/ _jsxs("h2", {
                                        className: "modal-title",
                                        children: [
                                            headerTitle,
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "modal-tv-box-subtitle",
                                                children: stbName
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    onClick: this.props.closeModal,
                                    className: "icon icon-clear pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SideBarMenu, {
                            sideMenuTabs: sideMenuTabs,
                            componentMap: COMPONENT_MAP,
                            toggleComponent: this.toggleComponent
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "active-section-title",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: title1
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "account-content float-right",
                            children: [
                                /*#__PURE__*/ _jsx(_$Component, _object_spread({
                                    toggleComponent: this.toggleComponent,
                                    i18n: i18n,
                                    currentBox: addon
                                }, activeComponent.props)),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "float-left free-shipping center-vertical",
                                            children: footerText
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "center-vertical discount-wrapper",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "price-wrapper column",
                                                children: [
                                                    hasPromoPrice && /*#__PURE__*/ _jsx("span", {
                                                        className: "original-price",
                                                        children: formatPrice(originalPrice, currencyCode)
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "discounted-price",
                                                        children: formatPrice(hasPromoPrice ? discountedPrice : originalPrice, currencyCode)
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return BoxSpecification;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default withSnackbar(connect(mapStateToProps, {
    closeModal: closeModal
})(BoxSpecification));
